@use "assets/styles/abstracts/variables" as v;
@use "assets/styles/abstracts/mixins/typography" as t;

.loader {
    width: 40px;
    height: auto;
}

.contactForm {
    flex: 1;
}

.select {
    width: 100%;
}

.wrapperSelects {
    display: flex;
    flex-direction: column;
    margin-bottom: 32px;
    gap: 16px;

    @media (min-width:768px) {
        flex-direction: row;
        align-items: flex-start;

        > * {
            flex: 1;
        }
    }
}

.toolSelectItemIcon {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;

    img {
        width: 22px;
        height: 22px;
    }
}

.wrapperInputs {
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.BorderPadding {
    padding-top: 32px;
    border-top: 1px solid v.$palette-gray-700;
}

.requestUpRowTwo {
    display: flex;
    flex-direction: column;
    gap: 32px;

    @media (min-width:768px) {
        flex-direction: row;
        align-items: flex-start;

        > * {
            flex: 1;
        }
    }
}

.userUpRowTwo {
    display: flex;
    flex-direction: column;
    gap: 32px;

    @media (min-width:768px) {
        flex-direction: row;
        align-items: flex-start;
        gap: 16px;
        
        > * {
            flex: 1;
        }
    }
}

.termsText {
    @include t.text(14px, 22px, "normal");
    color: v.$palette-white;
    text-align: center;
    margin: 0;
}

.termsLink {
    color: v.$palette-white;
    text-decoration: underline;
    text-underline-position: from-font;
}

.submitError {
    color: v.$error-color;
    @include t.text(14px, 22px, "normal");
    text-align: center;
    margin: 0;
}

.submitButton {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
    width: 100%;
    padding: 8px 24px;
    border: none;
    border-radius: 8px;
    background: v.$palette-green-500;
    color: v.$palette-white;
    cursor: pointer;
    @include t.text(16px, 26px, "semi-bold");
    text-align: center;
    transition: background 0.2s ease;

    &:disabled {
        cursor: not-allowed;
    }
}

.contactFormTitle {
    @include t.text(36px, 48px, bold);
    color: v.$palette-white;
    margin-bottom: 8px
}

.contactFormSubtitle {
    @include t.text(20px, 30px, semi-bold);
    color: v.$palette-white;
    margin-bottom: 40px;
}